/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R2_ChannelInputs */

const tr_kvkkbasvuru_s2_r2_channel = /** @type {(inputs: Kvkkbasvuru_S2_R2_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const en_kvkkbasvuru_s2_r2_channel = /** @type {(inputs: Kvkkbasvuru_S2_R2_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_kvkkbasvuru_s2_r2_channel = /** @type {(inputs: Kvkkbasvuru_S2_R2_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const ru_kvkkbasvuru_s2_r2_channel = /** @type {(inputs: Kvkkbasvuru_S2_R2_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Kvkkbasvuru_S2_R2_ChannelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r2_channel = /** @type {((inputs?: Kvkkbasvuru_S2_R2_ChannelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R2_ChannelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r2_channel(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r2_channel(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r2_channel(inputs)
	return tr_kvkkbasvuru_s2_r2_channel(inputs)
});